/* Charm Select*/
document.addEventListener("DOMContentLoaded", function () {
  const maxSelection = 3;
  const checkboxes = document.querySelectorAll(".ymq-options-img-input");
  const labels = document.querySelectorAll(".ymq-options-img-label");

  // Selected Charms Section Elements
  const selectedCharmsSection = document.querySelector(
    ".selected-charms-section"
  );
  const selectedCharmsTitles = document.querySelector(
    ".selected-charms-titles"
  );
  const totalPriceSpan = document.querySelector(".total-additional-price");

  // Additional Price Section Elements
  const additionalPriceSection = document.querySelector(
    ".additional-price-section"
  );
  const additionalPriceSpan = document.querySelector(
    ".total-additional-prices"
  );

  // Total Price Display Element
  const totalPriceDisplay = document.getElementById("total-price");

  // "Add to Cart" Button Element
  const addToCartButton = document.querySelector(".product-form__submit");
  addToCartButton.disabled = true;
  addToCartButton.classList.add("disabled");
  // "Buy Now" Button Element
  const buyNowButton = document.getElementById("gokwik-buy-now");

  // Base Product Price (Real Price)
  // const basePrice = parseFloat('{{ real_price | replace: ",", "" }}') || 0;
  addToCartButton.addEventListener("click", function () {
    let productIds = [];
    if ($('input:radio[name="size_meta"]:checked')[0].id) {
      productIds.push(
        parseInt($('input:radio[name="size_meta"]:checked')[0].id)
      );
      let elements = document.querySelectorAll(
        ".spotlight-group input:checked"
      );
      elements.forEach((el, i) => {
        productIds.push(el.dataset.productId);
      });
      let itemsData = productIds.map((productId) => {
        return { id: productId, quantity: 1 };
      });
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items: itemsData }),
      })
        .then((response) => response.json())
        .then((cart) => {
          console.log("Items added to cart:", cart);
        })
        .catch((error) => console.error("Error adding items to cart:", error));
    } else {
      alert("Please Select Size First");
    }
  });
  function updateUI() {
    const checkedBoxes = document.querySelectorAll(
      ".ymq-options-img-input:checked"
    );
    const checkedCount = checkedBoxes.length;

    // Update Borders to indicate disabled state
    if (checkedCount >= maxSelection) {
      checkboxes.forEach(function (checkbox) {
        if (!checkbox.checked) {
          const label = document.querySelector(
            'label[for="' + checkbox.id + '"]'
          );
          if (label) label.classList.add("disabled-border");
        }
      });
    } else {
      labels.forEach(function (label) {
        label.classList.remove("disabled-border");
      });
    }

    // Calculate Total Charm Price
    let totalCharmPrice = 0;
    const charmTitles = [];

    checkedBoxes.forEach(function (checkbox) {
      const charmTitle = checkbox.value;
      const charmPrice = parseFloat(checkbox.getAttribute("data-price")) || 0;
      totalCharmPrice += charmPrice;
      charmTitles.push(charmTitle);
    });

    // Update Selected Charms List
    if (checkedCount > 0) {
      if (selectedCharmsSection) {
        selectedCharmsSection.style.display = "block";
        selectedCharmsTitles.textContent = charmTitles.join(", ");
        totalPriceSpan.textContent = `| Rs. ${totalCharmPrice.toFixed(2)}`;
      }

      // Update Total Price Display
      if (totalPriceDisplay) {
        const totalPrice = basePrice + totalCharmPrice;
        totalPriceDisplay.textContent = `₹${totalPrice.toFixed(2)}`;
      }

      // Update Additional Price Section
      if (additionalPriceSection && additionalPriceSpan) {
        additionalPriceSection.style.display = "block";
        additionalPriceSpan.textContent = `Rs. ${totalCharmPrice.toFixed(2)}`;
      }

      // **Enable the "Add to Cart" Button**
      if (addToCartButton && addToCartButton.dataset.available != "false") {
        addToCartButton.disabled = false;
        addToCartButton.classList.remove("disabled");
      }

      // **Enable the "Buy Now" Button**
      if (buyNowButton) {
        buyNowButton.disabled = false;
        buyNowButton.classList.remove("disabled");
      }
    } else {
      if (selectedCharmsSection) {
        selectedCharmsSection.style.display = "none";
        selectedCharmsTitles.textContent = "";
        totalPriceSpan.textContent = "| Rs. 0.00";
      }

      // Reset Total Price Display
      if (totalPriceDisplay) {
        totalPriceDisplay.textContent = `₹${basePrice.toFixed(2)}`;
      }

      // Hide Additional Price Section
      if (additionalPriceSection && additionalPriceSpan) {
        additionalPriceSection.style.display = "none";
        additionalPriceSpan.textContent = "Rs. 0.00";
      }
    }
  }

  // Event Listener for Charms Selection
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener("change", function () {
      const checkedCount = document.querySelectorAll(
        ".ymq-options-img-input:checked"
      ).length;
      if (checkedCount > maxSelection) {
        this.checked = false;
        alert("Only up to 3 charms can be selected.");
      }
      updateUI();
    });
  });

  // Function to Reset Charms Selection
  function resetCharmsSelection() {
    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        checkbox.checked = false;
      }
    });
    updateUI();
  }

  // Event Listener for Option Tabs
  const optionItems = document.querySelectorAll(
    ".ecom-product-single__picker-radio-list-item"
  );
  optionItems.forEach(function (item) {
    item.addEventListener("click", function () {
      // Delay the reset to ensure the active class is updated first
      setTimeout(function () {
        resetCharmsSelection();
      }, 100);
    });
  });

  // Prevent "Buy Now" Click if No Charm is Selected (Optional)
  if (buyNowButton) {
    buyNowButton.addEventListener("click", function (e) {
      const checkedCount = document.querySelectorAll(
        ".ymq-options-img-input:checked"
      ).length;
      if (checkedCount === 0) {
        e.preventDefault();
        alert("Please select at least one charm before buying now.");
      }
    });
  }
  updateUI();
  // Set initial image and swatch title based on the first active size option
  var initialImageSrc = $('input[name="swatch"]:checked').data("image");
  $("#second-product-image").attr("src", initialImageSrc);
  var initialSwatchId = $('input[name="swatch"]:checked').data("sw-target");
  $(".product-title").addClass("hidden");
  $("#title-" + initialSwatchId).removeClass("hidden");
  $('input[name="swatch"]').change(function () {
    var newImageSrc = $(this).data("image");
    var newSwatchId = $(this).data("sw-target");
    $("#second-product-image").attr("src", newImageSrc);
    $(".product-title").addClass("hidden");
    $("#title-" + newSwatchId).removeClass("hidden");
  });
});

$('input[name="ymq[Choose a Charm]"]').change(function () {
  if ($(this).is(":checked")) {
    var selectedTitle = $(this).val();
    $("#media-product-title").text(selectedTitle);
  }
});

/* Select Letter */
$(document).ready(function () {
  function updateSelection() {
    $("label").removeClass("enable").addClass("disable");
    var selectedLabel = $(
      'input[type="radio"][name="select_letter"]:checked'
    ).next("label");
    selectedLabel.removeClass("disable").addClass("enable");
  }
  var firstRadio = $('input[type="radio"][name="select_letter"]').first();
  firstRadio.prop("checked", true);
  updateSelection();
  $('input[type="radio"][name="select_letter"]').on("change", function () {
    updateSelection();
  });
});

let galleryArray = [];

$("[data-product-grid]")
  .find(".resize-icon")
  .each(function () {
    let item = {
      src: this.getAttribute("href"),
      w: this.dataset.width,
      h: this.dataset.height,
    };
    galleryArray.push(item);
  });

function changeFire(event) {
  // Prevent default behavior (preventing navigation)
  event.preventDefault();
  let $pswp = $(".pswp")[0],
    options = {
      index: event.currentTarget.dataset.position - 1,
      bgOpacity: 0.85,
      closeOnScroll: false,
    };
  let gallery = new PhotoSwipe(
    $pswp,
    PhotoSwipeUI_Default,
    galleryArray,
    options
  );
  gallery.init();
}

let swgalleryArray = [];

$("[sw-data-product-grid]")
  .find(".sw-resize-icon")
  .each(function () {
    let items = {
      src: this.getAttribute("href"),
      w: this.dataset.width,
      h: this.dataset.height,
    };
    swgalleryArray.push(items);
  });

function swchangeFire(event) {
  // Prevent default behavior (preventing navigation)
  event.preventDefault();
  let $pswp = $(".pswp")[0],
    options = {
      index: event.currentTarget.dataset.position - 1,
      bgOpacity: 0.85,
      closeOnScroll: false,
    };
  let gallery = new PhotoSwipe(
    $pswp,
    PhotoSwipeUI_Default,
    swgalleryArray,
    options
  );
  gallery.init();
}
